import omit from 'lodash/omit';
import mapProps from 'recompose/mapProps';

const omitProps = keys => mapProps(props => omit(props, keys));

export default omitProps;
